import { useCallback, useEffect, useState } from "react";

// V4.3 — Mirror/Module TTS auto-play preference. Default OFF: replies are NOT
// spoken automatically (auto-play silently burned the Free 3-min TTS cap
// without the user choosing it). The user opts back in via Settings; on-demand
// playback is always available via the per-message "listen" button.
const KEY = "vyv_audio_autoplay";
const EVT = "vyv_audio_autoplay_change";

export function getAudioAutoplay(): boolean {
  try {
    return localStorage.getItem(KEY) === "true";
  } catch {
    return false;
  }
}

export function setAudioAutoplay(value: boolean): void {
  try {
    localStorage.setItem(KEY, value ? "true" : "false");
  } catch {
    /* ignore storage failures */
  }
  // Notify same-tab listeners (storage event only fires cross-tab).
  window.dispatchEvent(new CustomEvent(EVT, { detail: value }));
}

export function useAudioAutoplay(): [boolean, (v: boolean) => void] {
  const [on, setOn] = useState<boolean>(getAudioAutoplay);

  useEffect(() => {
    const sync = () => setOn(getAudioAutoplay());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const set = useCallback((v: boolean) => setAudioAutoplay(v), []);
  return [on, set];
}
